import { Outlet, useSearchParams } from 'react-router-dom';

import styled from 'styled-components';

import Header from 'components/common/Header';
import Snb from 'components/common/Snb';
import useCheckStaff from 'hooks/app/useCheckStaff';

const CommonLayout = () => {
	useCheckStaff();

	return (
		<>
			<LayoutWrapper>
				<Header />
				<LayoutInner>
					<Snb />
					<Outlet />
				</LayoutInner>
			</LayoutWrapper>
		</>
	);
};

const LayoutWrapper = styled.div`
	width: 100%;
	height: 100%;

	${({ theme }) => theme.common.flexStart}
	flex-direction: column;
`;

const LayoutInner = styled.div`
	width: 100%;
	height: calc(100% - 76px);

	${({ theme }) => theme.common.flexStart}
`;

export default CommonLayout;
